import type { TPageTranslations } from '@crehana/i18n';

import { DIPLOMAS_TRANSLATION_KEY } from '../constants';
import type { DiplomasLocaleKeys } from '../types';

const pt: TPageTranslations<
  DiplomasLocaleKeys,
  typeof DIPLOMAS_TRANSLATION_KEY
> = {
  [DIPLOMAS_TRANSLATION_KEY]: {
    // Empty view
    EMPTY_VIEW_TITLE: 'Você ainda não tem nenhum diploma',
    EMPTY_VIEW_DESC:
      'Depois de concluir 100% de seus cursos ou aprovar seus projetos, você poderá obter seus diplomas.',
    EMPTY_VIEW_BUTTON: 'Ir a meus projetos',
    EMPTY_VIEW_DEGREE_DESC:
      'Una vez que completes todos los cursos y entregues tus proyectos parciales, tendrás que avanzar tu proyecto final y aprobarlo para poder obtener tu diploma de MicroDegree.',
    EMPTY_VIEW_DEGREE_BUTTON: 'Ir a mi MicroDegree',
    EMPTY_VIEW_BUTTON_USER_HE: 'Ir a meus rutas',
    // Error view
    DIPLOMAS_ERROR: 'Ocorreu um erro ao obter seus diplomas',
    GENERAL_ERROR: 'Ocorreu um erro',
    TRY_AGAIN: 'Tente novamente',
    INTERNET_CONNECTION_ERROR: 'Ocorreu um erro de conexão',
    RELOAD_PAGE: 'Recarregue a página',
    CERTIFICATE: 'CERTIFICADO',
    TRACK: 'TRILHA',
    CONSTANCE: 'CONSTANCIA',
  },
};

export default pt;
